import { GripVertical } from "lucide-react";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";
import type { ScheduleSwapRow } from "./use-schedule-swap-row";

export function ScheduleDragHandle({
  row,
  label,
  className,
}: {
  row: ScheduleSwapRow;
  label: string;
  className?: string;
}) {
  const cursorClass = row.isDragging ? "cursor-grabbing" : "cursor-grab";
  return (
    <Button
      ref={row.setActivatorNodeRef}
      type="button"
      variant="ghost"
      size="icon-xs"
      {...row.attributes}
      {...row.listeners}
      // Keeps DESIGN.md's keyboard entry order; dnd-kit's attributes set 0.
      tabIndex={-1}
      aria-label={label}
      className={cn(
        "w-4 touch-none rounded text-neutral-400 hover:text-neutral-900",
        cursorClass,
        className,
      )}
    >
      <GripVertical className="size-3.5" />
    </Button>
  );
}
